import React from 'react';

import styled from 'styled-components';

import { getMoment } from '@libs/NwMoment';
import { showDateNoTime, showTime, isAllDay } from '@libs/NwMoment';
import { isFullDay } from '@libs/NwMoment';

import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const TimeContainer = styled.div`
    text-transform: uppercase;
    white-space: nowrap;
    min-width: 8.5rem;
    opacity: ${(props) => props.isAvailable && 0.5};
    text-align: left;
    width: 100%;
    font-weight: bold;

    .first-line {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 0.5rem;

        .start-end-time {
            display: flex;
            flex-direction: row;
            .start-time {
                margin-right: 10px;
            }
        }

        span {
            display: block;
            font-size: 0.9rem;
            font-weight: bold;

            &.reminder {
                color: ${(props) => props.theme.DangerColor};
                font-size: 1rem;
            }
        }

        small {
            display: block;
            font-weight: normal;
            font-size: ${(props) => props.theme.FontSizeSm};

            em {
                display: block;
                font-style: normal;
            }
        }

        div.end-date {
            display: flex;
            justify-content: flex-end;
            align-items: center;

            svg {
                margin-right: 1em;
            }
        }

        div.started-date {
            display: block;
        }

        .more-times {
            font-size: 0.8rem;
            font-weight: normal;
        }
    }

    .call-time {
        padding-top: 0.5rem;
        font-size: ${(props) => props.theme.FontSizeSm};
        font-weight: normal;
        text-transform: uppercase;
        line-height: 1.1em;
    }

    .period-time {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;

        .period-time-left {
            flex: 1;
        }
        .period-time-right {
            text-align: right;
            font-size: ${(props) => props.theme.FontSizeXSm};
            font-weight: normal;
            p {
                margin: 0;
                line-height: 1.1em;
            }
        }
    }
`;

const TimeWithBreaks = ({ st, et, sb, eb }) => {
    return (
        <div className="double-time-wrapper">
            <div className="start-end-time">
                <span className="start-time">{showTime(st)}</span>
                <div className="end-date">
                    <span>
                        <NwIcon icon={byPrefixAndName.fasl['arrow-to-right']} size="xs" />
                    </span>
                    <span className="end-time">{showTime(sb)}</span>
                </div>
            </div>
            <div className="start-end-time">
                <span className="start-time">{showTime(eb)}</span>
                <div className="end-date">
                    <span>
                        <NwIcon icon={byPrefixAndName.fasl['arrow-to-right']} size="xs" />
                    </span>
                    <span className="end-time">{showTime(et)}</span>
                </div>
            </div>
        </div>
    );
};

const SimpleTime = ({ st, et }) => {
    return (
        <div className="start-end-time">
            <span className="start-time">{showTime(st)}</span>
            <div className="end-date">
                <span>
                    <NwIcon icon={byPrefixAndName.fasl['arrow-to-right']} size="xs" />
                </span>
                <span className="end-time">{showTime(et)}</span>
            </div>
        </div>
    );
};

const OnlyStartTime = ({ st }) => {
    return <span className="start-time">{showTime(st)}</span>;
};

const AllDayTime = () => {
    return <span className="all-day">ALL DAY</span>;
};

const NoTimes = ({ st, et }) => {
    return (
        <>
            <div className="start-date">
                <span className="end-time">{showDateNoTime(st)}</span>
            </div>
            <div className="end-date">
                <span>
                    <NwIcon icon={byPrefixAndName.fasl['arrow-to-right']} size="xs" />
                </span>
                <span className="end-time">{showDateNoTime(et)}</span>
            </div>
        </>
    );
};

// const PeriodTime = ({ st, et }) => {
//     return (
//         <>
//             <div className="started-date">
//                 <small>
//                     <strong>STARTED ON</strong>
//                 </small>
//                 {isFullDay(st, et) ? (
//                     <small>{showDateNoTime(st)}</small>
//                 ) : (
//                     <small>
//                         {showDateNoTime(st)} • {showTime(st)}
//                     </small>
//                 )}
//             </div>
//             <div className="started-date">
//                 <small>
//                     <strong>WILL END ON</strong>
//                 </small>
//                 {isFullDay(st, et) ? (
//                     <small>{showDateNoTime(et)}</small>
//                 ) : (
//                     <small>
//                         {showDateNoTime(et)} • {showTime(et)}
//                     </small>
//                 )}
//             </div>
//         </>
//     );
// };

// const PeriodEnd = ({ st, et }) => {
//     return (
//         <div className="start-end-time">
//             <span className="start-time">
//                 <NwIcon icon={byPrefixAndName.fasl['arrow-to-right']} />{' '}
//                 {isFullDay(st, et) ? showDateNoTime(et) : showTime(et)}
//             </span>
//             <div className="started-date">
//                 <small>STARTED ON</small>
//                 {isFullDay(st, et) ? (
//                     <small>{showDateNoTime(st)}</small>
//                 ) : (
//                     <small>
//                         {showDateNoTime(st)} • {showTime(st)}
//                     </small>
//                 )}
//             </div>
//         </div>
//     );
// };

// const PeriodStart = ({ st, et }) => {
//     return (
//         <div className="start-end-time">
//             <span className="start-time">{isFullDay(st, et) ? showDateNoTime(st) : showTime(st)}</span>
//             <div className="end-date">
//                 <small>
//                     <NwIcon icon={byPrefixAndName.fasl['arrow-to-right']} />
//                 </small>
//                 <div>
//                     <small>{showDateNoTime(et)}</small>
//                     {!isFullDay(st, et) && <small>{showTime(et)}</small>}
//                 </div>
//             </div>
//         </div>
//     );
// };

const PeriodTime = ({ st, et, currentDate }) => {
    // Helper to render the common right side with start/end dates
    const renderDateInfo = () => (
        <div className="period-time-right">
            <p>
                START:{' '}
                <strong>{isFullDay(st, et) ? showDateNoTime(st) : `${showDateNoTime(st)} • ${showTime(st)}`}</strong>
            </p>
            <p>
                END:{' '}
                <strong>{isFullDay(st, et) ? showDateNoTime(et) : `${showDateNoTime(et)} • ${showTime(et)}`}</strong>
            </p>
        </div>
    );

    if (!currentDate) {
        // No current date provided, show simple date range
        return <NoTimes st={st} et={et} />;
    }

    const date = getMoment(currentDate);
    let leftContent;

    if (!st.isSame(date, 'days') || isAllDay(st, et)) {
        // It's not start date
        if (!et.isSame(date, 'days') || isAllDay(st, et)) {
            // Between start and end
            leftContent = 'ALL DAY';
        } else {
            // It's end date
            leftContent = `until ${showTime(et)}`;
        }
    } else {
        // It's start date
        leftContent = `from ${showTime(st)}`;
    }

    return (
        <div className="period-time">
            <div className="period-time-left">{leftContent}</div>
            {renderDateInfo()}
        </div>
    );
};

const MobileAgendaEventTime = ({ event, eventType, isAvailable = false, currentDate = null }) => {
    const st_string = event.FromDate;
    const et_string = event.ToDate;
    const sb_string = event.StartBreak;
    const eb_string = event.EndBreak;
    const st = getMoment(st_string);
    const et = getMoment(et_string);
    const sb = sb_string ? getMoment(sb_string) : null;
    const eb = eb_string ? getMoment(eb_string) : null;
    const call_time = event.CallTime;
    const moddates = event.ModelsDates;

    let dontShowCallTime = false;
    let showMoreTimes = false;

    const showBookingEventTime = (st, et, sb, eb) => {
        if (sb && eb) {
            return <TimeWithBreaks st={st} et={et} sb={sb} eb={eb} />;
        }
        if (st.hours() === 0 && st.minutes() === 0 && et.hours() === 23 && et.minutes() === 59) {
            return <AllDayTime />;
        } else {
            if (st.hours() === et.hours() && st.minutes() === et.minutes()) {
                return <OnlyStartTime st={st} />;
            } else {
                return <SimpleTime st={st} et={et} />;
            }
        }
    };

    const writeTime = () => {
        if (!eventType) {
            // Fallback for when eventType is not provided
            if (!et || st.isSame(et, 'minute')) {
                return <OnlyStartTime st={st} />;
            }
            if (et && st.isSame(et, 'day')) {
                if (st.hours() === 0 && st.minutes() === 0 && et.hours() === 23 && et.minutes() === 59) {
                    return <AllDayTime />;
                }
                return <SimpleTime st={st} et={et} />;
            } else {
                return <NoTimes st={st} et={et} />;
            }
        }

        switch (eventType.code.toLowerCase()) {
            case 'casting':
            case 'job':
            case 'ext':
                let timetoshow = '';
                if (moddates && moddates.length > 1) {
                    //sort moddates by FromDate
                    const sortedModdates = moddates.sort((a, b) => getMoment(a.FromDate).diff(getMoment(b.FromDate)));
                    const stmd = getMoment(sortedModdates[0].FromDate);
                    const etmd = getMoment(sortedModdates[0].ToDate);
                    const sbmd = sortedModdates[0].StartBreak ? getMoment(sortedModdates[0].StartBreak) : null;
                    const ebmd = sortedModdates[0].EndBreak ? getMoment(sortedModdates[0].EndBreak) : null;
                    timetoshow = showBookingEventTime(stmd, etmd, sbmd, ebmd);
                    if (sortedModdates.length > 1) {
                        dontShowCallTime = true;
                        showMoreTimes = true;
                    }
                } else {
                    timetoshow = showBookingEventTime(st, et, sb, eb);
                }
                return timetoshow;
            default:
                if (!et || st.isSame(et, 'minute')) {
                    //single date (no endtime)
                    return <OnlyStartTime st={st} />;
                }
                if (et && st.isSame(et, 'day')) {
                    if (st.hours() === 0 && st.minutes() === 0 && et.hours() === 23 && et.minutes() === 59) {
                        return <AllDayTime />;
                    }
                    return <SimpleTime st={st} et={et} />;
                } else {
                    return <PeriodTime st={st} et={et} currentDate={currentDate} />;
                }
        }
    };

    return (
        <TimeContainer isAvailable={isAvailable}>
            <div className="first-line">
                {writeTime()}
                {showMoreTimes && <span className="more-times">(and more)</span>}
            </div>
            {call_time && !dontShowCallTime && (
                <span className="call-time">
                    Call Time
                    <br />
                    {call_time}
                </span>
            )}
        </TimeContainer>
    );
};

export default MobileAgendaEventTime;
